import { Component, OnInit } from '@angular/core';
import { MessagesHandler } from './messages.handler';
import { NotificationService } from '../services/notifications.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';

@Component({
  selector: 'sym-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent extends MessagesHandler implements OnInit {
  constructor(
    public service: NotificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, headerService, router, settingService, offlineService);
  }
}
